export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function parseTimeToMinutes(value) {
  if (typeof value !== 'string' || !/^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/.test(value)) return null;
  const [hour, minute] = value.split(':').map(Number);
  return hour * 60 + minute;
}

export function formatTimeLabel(value) {
  const minutes = parseTimeToMinutes(value);
  if (minutes === null) return null;
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${hour % 12 || 12}${minute ? `:${String(minute).padStart(2, '0')}` : ''} ${hour >= 12 ? 'PM' : 'AM'}`;
}

function interval(row) {
  // The existing editor explicitly stores null/null for its Closed checkbox.
  if (!row) return { kind: 'unknown' };
  if (row.openTime === null && row.closeTime === null) return { kind: 'closed' };
  const open = parseTimeToMinutes(row.openTime);
  const close = parseTimeToMinutes(row.closeTime);
  return open !== null && close !== null && open !== close ? { kind: 'open', open, close } : { kind: 'unknown' };
}

export function formatHoursValue(row) {
  const value = interval(row);
  if (value.kind === 'closed') return 'Closed';
  if (value.kind === 'unknown') return 'Hours unavailable';
  return `${formatTimeLabel(row.openTime)} - ${formatTimeLabel(row.closeTime)}${value.close < value.open ? ' (next day)' : ''}`;
}

export function getStatusLabel(rows, now, timezone) {
  if (!Array.isArray(rows) || !rows.length || !Number.isFinite(now?.getTime())) return 'Hours unavailable';
  let day, minutes;
  try {
    if (timezone) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: timezone, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(now).map(part => [part.type, part.value]));
      day = DAY_NAMES.indexOf(parts.weekday); minutes = Number(parts.hour) * 60 + Number(parts.minute);
    } else { day = now.getDay(); minutes = now.getHours() * 60 + now.getMinutes(); }
  } catch { return 'Business hours'; }
  const byDay = new Map(rows.filter(row => Number.isInteger(row?.dayOfWeek) && row.dayOfWeek >= 0 && row.dayOfWeek <= 6).map(row => [row.dayOfWeek, row]));
  const today = interval(byDay.get(day));
  const yesterday = interval(byDay.get((day + 6) % 7));
  if (yesterday.kind === 'open' && yesterday.close < yesterday.open && minutes < yesterday.close) return `Open · Closes at ${formatTimeLabel(byDay.get((day + 6) % 7).closeTime)}`;
  if (today.kind === 'open' && minutes >= today.open && (today.close < today.open || minutes < today.close)) return `Open · Closes at ${formatTimeLabel(byDay.get(day).closeTime)}`;
  const knownClosed = today.kind !== 'unknown' && yesterday.kind !== 'unknown';
  for (let offset = 0; offset <= 7; offset++) {
    const nextDay = (day + offset) % 7;
    const row = byDay.get(nextDay);
    const value = interval(row);
    if (value.kind !== 'open' || (offset === 0 && value.open <= minutes)) continue;
    const dayText = offset === 0 ? 'today' : DAY_NAMES[nextDay];
    const opening = `${dayText} at ${formatTimeLabel(row.openTime)}`;
    return knownClosed ? `Closed · Opens ${opening}` : `Next listed opening: ${opening}`;
  }
  return knownClosed ? 'Closed' : 'Hours unavailable';
}
